if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.recentlyViewed = [];
        this.filteredProducts = [];
    }

    connectedCallback() {
      this.updateLocalStorage();
      if (!this.recentlyViewed) return;

      this.populateRecentlyViewed();
    }

    async populateRecentlyViewed() {                
      for (let i = 0; i < this.recentlyViewed?.length; i++) {
        const productHandle = this.recentlyViewed[i];
        if (i > 8 || !productHandle) break;
        
        if (productHandle !== this.productHandle) {
          await fetch(`/products/${productHandle}.json`)
            .then((response) => {
              if (!response.ok) return;
              return response.json();
            })
            .then((data) => {
              const product = data?.product;
              if (!product) return;
              const tags = product.tags.split(',').map(item => item.trim())
              const bannedtags = ['base-product', 'hide-product', 'base_product', 'hide_product'];
                          
              if (!bannedtags.some(i => tags.includes(i))) this.filteredProducts.push(product.handle);
            })
            .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      
      if (!this.filteredProducts.length) {
        this.closest('.shopify-section')?.remove();
        return;
      }
      
      this.innerHTML = `
        <div class="relative z-[1]">
          <swiper-carousel 
            data-space-between="8"
            data-slides-per-view="4"
            data-slides-per-view-mobile="2.5"
            class="hidden md:flex flex-col w-full pb-8"
            data-pagination="true"
            data-external-nav-buttons="recently-viewed-slider"
          >
            <button data-prev="recently-viewed-slider" class="button-slider disabled:hidden absolute left-0 top-1/2 z-10 bg-secondaryLight border-primaryLight transform -translate-x-1/2 shadow-lg" data-prev>
              <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
              </svg>
            </button>
            <button data-next="recently-viewed-slider" class="button-slider disabled:hidden absolute right-0 top-1/2 z-10 bg-secondaryLight border-primaryLight shadow-lg transform translate-x-1/2" data-next>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
              </svg>
            </button>
            <div class="swiper-wrapper">
              ${this.filteredProducts.map((product) => `
                <div class="swiper-slide [&_product-tile]:h-full !h-auto">
                  <intersection-loader 
                    data-url="/products/${product}" 
                    data-section-id="recently-viewed-product-tile"
                    data-load-immediately="true"
                  ></intersection-loader>                    
                </div>
              `).join('')}
            </div>
          </swiper-carousel>
          <div class="grid grid-cols-2 gap-4 md:hidden">
                ${this.filteredProducts.map((product) => `
                  <div class="swiper-slide [&_product-tile]:h-full !h-auto">
                    <intersection-loader 
                      data-url="/products/${product}" 
                      data-section-id="recently-viewed-product-tile"
                      data-load-immediately="true"
                    ></intersection-loader>                    
                  </div>
                `).join('')}
          </div>
        </div>
      `;
    }

    updateLocalStorage() {
      if (localStorage.getItem('orthofeet:recentlyViewedProducts')) {
        this.recentlyViewed = [...new Set([...localStorage.getItem('orthofeet:recentlyViewedProducts')?.split(',')])].slice(0, 5) ?? [];
      }

      if ((this.recentlyViewed[this.productHandle]) || !this.productHandle) return;
      localStorage.setItem('orthofeet:recentlyViewedProducts', `${this.productHandle}${this.recentlyViewed ? `,${this.recentlyViewed}` : ''}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}